import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ArticleCard from '@/components/base/ArticleCard';
import { getArticlesByCategory } from '@/mocks/articles';

const categoryNames: Record<string, string> = {
  'getting-started': '入门指南',
  membership: '会员指南',
  community: '社区攻略',
};

export default function CategoryDetail() {
  const { slug } = useParams<{ slug: string }>();
  const categoryName = slug ? categoryNames[slug] || '分类' : '分类';
  const articles = slug ? getArticlesByCategory(slug) : [];

  useEffect(() => {
    document.title = `${categoryName} | JM Comic – 官方入口与完整使用指南`;
  }, [categoryName]);

  return (
    <div className="min-h-screen bg-background-50">
      <Breadcrumb
        items={[
          { label: '分类导航', to: '/categories' },
          { label: categoryName },
        ]}
      />

      <section className="py-10 md:py-14">
        <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
          <div className="mb-10">
            <h1 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-2">
              {categoryName}
            </h1>
            <p className="text-foreground-600">
              共 {articles.length} 篇文章
            </p>
          </div>

          {articles.length > 0 ? (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {articles.map((article) => (
                <ArticleCard
                  key={article.slug}
                  slug={article.slug}
                  title={article.title}
                  excerpt={article.excerpt}
                  coverImage={article.coverImage}
                  categoryName={article.categoryName}
                  publishDate={article.publishDate}
                  readTime={article.readTime}
                  author={article.author}
                />
              ))}
            </div>
          ) : (
            <div className="text-center py-20">
              <div className="w-16 h-16 flex items-center justify-center bg-background-100 rounded-full mx-auto mb-4">
                <i className="ri-inbox-line text-2xl text-foreground-400"></i>
              </div>
              <p className="text-foreground-600">该分类下暂无文章</p>
            </div>
          )}
        </div>
      </section>
    </div>
  );
}